export default __webpack_public_path__ + "static/media/account-star.8b20ad33.svg";